import script from "./HeaderUserMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderUserMenu.vue?vue&type=script&setup=true&lang=js"

import "./HeaderUserMenu.vue?vue&type=style&index=0&id=1f501b15&lang=scss"

const __exports__ = script;

export default __exports__